import { render } from "./ManageProfile.vue?vue&type=template&id=f9dd5c54&scoped=true"
import script from "./ManageProfile.vue?vue&type=script&lang=js"
export * from "./ManageProfile.vue?vue&type=script&lang=js"

import "./ManageProfile.vue?vue&type=style&index=0&id=f9dd5c54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9dd5c54"]])

export default __exports__